import { createReducer } from "@reduxjs/toolkit";
import { GetSalesOrder,GetSalesQuotation, GetOrderHistory, GetQuotationDetails, GetsearchHistory } from "./HistoryThunk";

const handleAsyncActions = (builder, action, stateKey, errorKey) => {
    builder
        .addCase(action.pending, (state) => {
            state.loading[stateKey] = true; 
            state[stateKey] = null;
            state.error[errorKey] = null;
        })
        .addCase(action.fulfilled, (state, action) => {
            state.loading[stateKey] = false; 
            state[stateKey] = action.payload; 
            if(stateKey === 'SalesQuotation'){
                localStorage.setItem('PAGEData', 'SQ')
            }else if (stateKey === 'SalesOrder'){
                localStorage.setItem('PAGEData', 'SO')
            }
            if(stateKey === 'QuotationDetails') {               
                sessionStorage.setItem('HistoryDetails', JSON.stringify(action.payload))
            }else if (stateKey === 'OrderHistory') {                
                sessionStorage.setItem('HistoryDetails', JSON.stringify(action.payload))
            }
            state.error[errorKey] = null; 
        })
        .addCase(action.rejected, (state, action) => {
            state.loading[stateKey] = false; 
            state.error[errorKey] = action.payload; 
        });
};

const initialState = {
    SalesQuotation: null,
    SalesOrder: null,
    OrderHistory:null,
    QuotationDetails:null,
    searchHistoryData:null,

    loading: {
        SalesQuotation: false,
        SalesOrder: false,
        OrderHistory:false,
        QuotationDetails:false,
        searchHistoryData:false,
    },

    error: {
        SalesQuotationError: null,
        SalesOrderError: null,
        OrderHistoryError:null,
        QuotationDetailsError:null,
        searchHistoryError:null,
    },
};

export const HistoryReducer = createReducer(initialState, (builder) => {
    handleAsyncActions(builder, GetSalesQuotation, "SalesQuotation", "SalesQuotationError");
    handleAsyncActions(builder, GetSalesOrder, "SalesOrder", "SalesOrderError");
    handleAsyncActions(builder, GetOrderHistory, "OrderHistory", "OrderHistoryError");
    handleAsyncActions(builder, GetQuotationDetails, "QuotationDetails", "QuotationDetailsError");
    handleAsyncActions(builder, GetsearchHistory, "searchHistoryData", "searchHistoryError");

});

export default HistoryReducer;
